import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { setChart, saveConfig, updateLineChart, updateBreakdown } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../ThroughputActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import ThroughputBreakdown from '../components/ThroughputBreakdown';
import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';
import ThroughputChart from './../components/ThroughputChart';
import ExactThroughput from '../components/ExactThroughput';

import { 
  trackTeamDashboardView , 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import './../Throughput.scss';
import ChartDownloadMenu from '../../../components/ChartDownloadMenu';
import chartUtils from '../../../util/chartUtils';

class Throughput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handlePointClick = this.handlePointClick.bind(this);
    this.handleCloseThroughput = this.handleCloseThroughput.bind(this);
    this.handleCloseBreakdown = this.handleCloseBreakdown.bind(this);

    props.dispatch(setPageName('Throughput diagram'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('trc');

      trackTeamDashboardView('trc');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.enabledColors != this.props.enabledColors ||
        prevProps.selectedDate != this.props.selectedDate) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick(point) {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('trc', true);
  }

  trackHowToTRCOpen() {
    trackHowToOpened('trc');
  }

  handleCloseThroughput() {
    this.props.closeThroughput();
    this.props.saveConfig();
  }

  handleCloseBreakdown() {
    this.props.closeBreakdown();
    this.props.saveConfig();
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <h4>Throughput Run Chart</h4>
          <p>Bars show the number of work items completed per selected period. The optional trend line shows how throughput changes over time.</p>
          <p><b>Look for:</b> a downward trend, which can indicate fewer items are being completed over time.</p>
          <a
            //href={`https://www.youtube.com/watch?v=VPypRd_buuo&list=PLdQ4qpF6dHcJ5KpN51NyCNUb5bS6bbrpC&index=6`}
            href={`https://getnave.com/throughput-run-chart`}
            target="_blank"
            onClick={this.trackHowToTRCOpen}
            onAuxClick={this.trackHowToTRCOpen}
            className='more_info-link'
          >
            Learn more →
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data, (p, c) => {
      return p + _.reduce(c.data, (p, c) => p + c.details.length, 0);
    }, 0);

    const noData = !this.props.data.length || (_.every(this.props.data, d => d.data && _.every(d.data, item => item.y === 0 && (!item.details || item.details.length < 1))));
    
    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Throughput Run Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter
          totalItems={totalItems}
          showLineChart
          enableMarkBlocked
          timeunit
          dateformat
          enableTrendline
          enableSelectedDate
          colors="Breakdown by"
        />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>Throughput Run Chart</h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options showLineChart showBreakdown options={{ lineChartTooltip: 'Throughput' }} />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details">
            {this.props.lineChart && (chartUtils.hasValues(this.props.data) ? (
              <ExactThroughput data={this.props.data} dateFormat={this.props.dateFormat} widget="et" />
            ) : (
              <CardPlaceholder title="Throughput" shape="line" loading={this.props.isLoading} onClose={this.handleCloseThroughput} />
            ))}
            {this.props.breakdown && (chartUtils.hasValues(this.props.data) ? (
              <ThroughputBreakdown id="throughput-breakdown" data={this.props.data} widget="tb" />
            ) : (
              <CardPlaceholder
                title="Throughput breakdown"
                shape={this.props.breakdownType === 'pie' ? 'pie' : 'columns'}
                loading={this.props.isLoading}
                onClose={this.handleCloseBreakdown}
              />
            ))}
          </div>
          <div className="chart_row">
            <div className="diagram_details">
              <ChartDownloadMenu chartId="Throughput" />
              <ThroughputChart id="Throughput" data={this.props.data} onPointClick={this.handlePointClick} blockedTime={this.props.blockedTime} />
              <NoData show={!chartUtils.hasValues(this.props.data)} loading={this.props.isLoading} />
            </div>
            <DetailsAccordion
              id="details-accordion"
              dateLabel=""
              valueLabel="Throughput"
              value2Label="Cycle time"
              chart="trc"
              data={this.state.selectedPoint}
              blockedTime={this.props.blockedTime}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    closeThroughput: () => dispatch(updateLineChart(false, 'trc')),
    closeBreakdown: () => dispatch(updateBreakdown(false, 'trc')),
    saveConfig: () => dispatch(saveConfig())
  };
};

const mapStateToProps = state => {
  const customFields = _.map(state.filters.allCustomFields, cf => {
    return state.filters.trc[`selected${cf}`];
  });

  return {
    breakdownType: state.filters.trc.breakdownType,
    dateFormat: state.filters.dateFormat,
    enabledColors: state.filters.enabledColors,
    breakdown: state.filters.trc.breakdown,
    lineChart: state.filters.trc.lineChart,
    blockedTime: state.filters.trc.blockedTime,
    hash: state.filters.trc.hash,
    selectedDate: state.filters.trc.selectedDate,
    data: state.throughput.data,
    isLoading: state.throughput.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    customFields,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Throughput);
